export default __webpack_public_path__ + "static/CYAN_GLOW_BG-ddaab38eda11fd5e6e33a83db0410c1c.png";